import React, {h, Component} from 'preact';

export default class SellAgentPreferenceStep extends Component {

    componentDidMount() {
        trackEvent('Flow', 'SellRequest', 'sellV3Step2').withGA().withOptimizely();
    }

    chooseAgentPreference(preference, preferenceLabel) {
        this.props.parent.setState({
            agentPreference: preference,
            preferenceLabel: preferenceLabel,
            currentStep: 'SELL_HOME_TYPE'
        });
    }

    render() {
        return <div className="flow-step">
            <div className="flow-step-text hidden-xs" style={this.props.showAgentCount ? '' : 'visibility: hidden'}>
                <img className ="icon-desktop" src={global.imageBaseUrl + '/buysell/svg/top-agents.svg'} />
                <div>{this.props.parent.state.agentCount} UpNest partner agents specialized in {this.props.parent.state.priceRangeStr} price range.</div>
            </div>

            <div className="flow-step-header-text">
                <strong>It&apos;s most important that your agent ...</strong>
            </div>

            <div className="option-div">
                <div id="agent-preferences-div">
                    <div onClick={() => this.chooseAgentPreference('Sells Quickly', 'sell properties quickly')} className="choice-button agent-preference-button">
                        <img src={global.imageBaseUrl + '/buysell/svg/sells-quickly.svg'}/>
                        <div style={{overflow: 'hidden'}}>
                            <span className="button-text">Can sell quickly</span>
                        </div>
                    </div>
                    <div onClick={() => this.chooseAgentPreference('Best Price', 'can get the best price')} className="choice-button agent-preference-button">
                        <img src={global.imageBaseUrl + '/buysell/svg/best-price.svg'}/>
                        <div style={{overflow: 'hidden'}}>
                            <span className="button-text">Gets you the best price</span>
                        </div>
                    </div>
                    <div onClick={() => this.chooseAgentPreference('Experienced', 'are very experienced')} className="choice-button agent-preference-button">
                        <img src={global.imageBaseUrl + '/buysell/svg/experienced.svg'}/>
                        <div style={{overflow: 'hidden'}}>
                            <span className="button-text">Is very experienced</span>
                        </div>
                    </div>
                    <div onClick={() => this.chooseAgentPreference('Best Commission', 'have the best commission')} className="choice-button agent-preference-button">
                        <img src={global.imageBaseUrl + '/buysell/svg/best-commission.svg'}/>
                        <div style={{overflow: 'hidden'}}>
                            <span className="button-text">Has the best commission</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flow-spacer"/>

            <div className="bottom-banner" style={this.props.showAgentCount ? '' : 'display: none'}>
                <div className="status-normal">
                    <div className="title"><img src={global.imageBaseUrl + '/buysell/svg/top-agents.svg'}/> Top Performing Agents</div>
                    <div className="subtitle subtitle-large">{this.props.parent.state.agentCount} UpNest partner agents specialized in {this.props.parent.state.priceRangeStr} price range.</div>
                </div>
                <div className="status-normal subtitle subtitle-small">
                    {this.props.parent.state.agentCount} UpNest partner agents specialized in {this.props.parent.state.priceRangeStr} price range.
                </div>
            </div>
        </div>;
    }
}
